/**
 * @param data {Data}
 */
function thenSetUtmCookiesToDirectAfterFormSubmission(data) {
	const firstCookieExists = !!data.jsCookie.get(runFirstUtmCookieKey());
	if (firstCookieExists) {
		runSetUtmCookieToDirect(data.jsCookie);
	}
}